import { apiConfig } from 'config';
import { req } from 'utils/request';

const { account } = apiConfig;

export function getReportsApi(userId) {
  return req().get(account.reports(userId));
}
